import { Component, OnInit, NgZone } from '@angular/core';

import { Advisor } from '../models/advisor';

import { GlobalService } from '../services/global.service';
import { ModalService } from '../shared/modal/modal.service';
import { PagerService } from '../services/pager.service';

import { LoadingService } from '../shared/loading/loading.service';

@Component({
  selector: 'app-advisors',
  templateUrl: './advisors.component.html',
  styleUrls: ['./advisors.component.css']
})
export class AdvisorsComponent implements OnInit {
  public advisors: any[] = [];
  public error: string;

  public screenWidth: number = window.innerWidth;

  private allItems: any[];
  private filteredAdvisors: any;
  pager: any = {};
  pagedItems: any[];

  activeFirstNameArrow: boolean;
  activeOrgNameArrow: boolean;
  activeEmailArrow: boolean;

  public modalSubscription;

  constructor(private globalService:GlobalService, private modalService: ModalService, private pagerService: PagerService, private ngZone: NgZone, private loadingService: LoadingService) {
    this.getAdvisors();
    this.modalSubscription = modalService.modal$.subscribe((modal) => {
      console.log(modal.modalName);
      if (modal.modalName == 'create-advisorClosed') { // TODO: Fix this hack -- naming it hidden.. modals in general need to be refactored
        this.getAdvisors();
        modal.data = {};
      }
    });

    this.globalService.featHomeOffice = JSON.parse(localStorage.getItem('featHomeOffice'));
    // window.onresize = () => { // Detect screen size and resizing
    //   ngZone.run(() => {
    //     this.screenWidth = window.innerWidth;
    //   })
    // }
  }

  getAdvisors() {
    this.loadingService.isLoading(true);

    this.globalService.getAdvisorsData(1)
        .subscribe(
            advisors => {
              this.allItems = advisors;
              
              // this.allItems = this.allItems.reduce((arr, item) => {
              //   if (!!item.FirstName && item.FirstName != 'undefined')
              //     arr.push(item);
              //   return arr;
              // }, []);

              this.allItems = advisors.map((item) => { 
                item.c.OrganizationName = item.o.Name; 
                return item.c;
              });

              this.filteredAdvisors = this.allItems.sort(function (a, b) {
                return parseInt(b.ID) - parseInt(a.ID);
              });

              this.setPage(1);
              this.loadingService.isLoading(false);
            },
            error => {
              this.error = <any>error
              this.loadingService.isLoading(false);
            });
  }

  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }

    // get pager object from service
    this.pager = this.pagerService.getPager(this.filteredAdvisors.length, page);

    // get current page of items
    this.pagedItems = this.filteredAdvisors.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  ngOnInit() {

  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    // this.subscription.unsubscribe();
  }

  handleCreateAdvisorModal() {
    this.modalService.add('create-advisor', { ID: 0 });
  }

  handleEditAdvisorModal(e, advisor) {
    this.modalService.add('create-advisor', { ID: advisor.ID });
  }

  handleCreateClientModal(e, advisor) {
    this.modalService.add('add-edit-client', { ID: 0, Advisor: advisor });
  }

  assignCopy(){
    this.filteredAdvisors = Object.assign([], this.allItems);
  }

  filterItem(value) {
    this.filteredAdvisors = Object.assign([], this.allItems).filter(
      advisor => {
        return (advisor.FirstName + " " + advisor.LastName).toLowerCase().includes(value.toLowerCase()) || (advisor.OrganizationName).toLowerCase().includes(value.toLowerCase()) || (advisor.Phone).toLowerCase().includes(value.toLowerCase()) || (advisor.Email).toLowerCase().includes(value.toLowerCase())
      }
    );

    if (!this.filteredAdvisors.length) {
      this.pagedItems = [];
    } else {
      this.setPage(1);
    }
  }

  disableAllSortArrow() {
    this.activeFirstNameArrow = false;
    this.activeOrgNameArrow = false;
    this.activeEmailArrow = false;
  }

  private isColSortedAsc: any = {
    FirstName: false,
    OrganizationName: false,
    Email: false,
  }

  sort(colName) {
    this.disableAllSortArrow();
    if (colName == 'FirstName') {
      this.filteredAdvisors.sort((a, b) => this.isColSortedAsc[colName] ? (a.FirstName + a.LastName).localeCompare(b.FirstName + b.LastName) : (b.FirstName + b.LastName).localeCompare(a.FirstName + a.LastName));
      this.setPage(this.pager.currentPage);
      this.activeFirstNameArrow = this.isColSortedAsc[colName];
    }
    if (colName == 'OrganizationName') {
      this.filteredAdvisors.sort((a, b) => this.isColSortedAsc[colName] ? a.OrganizationName.localeCompare(b.OrganizationName ) : b.OrganizationName.localeCompare(a.OrganizationName ));
      this.setPage(this.pager.currentPage);
      this.activeOrgNameArrow = this.isColSortedAsc[colName];
    }
    if (colName == 'Email') {
      this.filteredAdvisors.sort((a, b) => this.isColSortedAsc[colName] ? a.Email.localeCompare(b.Email) : b.Email.localeCompare(a.Email));
      this.setPage(this.pager.currentPage);
      this.activeEmailArrow = this.isColSortedAsc[colName];
    }

    this.isColSortedAsc[colName] = !this.isColSortedAsc[colName];
  }

}
